import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { MaritalActions } from './marital.actions';
import { IMaritalState } from './marital.state';

export const initialMaritalState: IMaritalState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const maritalReducerFn = createReducer(
  initialMaritalState,
  on(MaritalActions.reset, (state: IMaritalState, action) => {
    return new StateBuilder<IMaritalState>(initialMaritalState).build();
  }),
  on(MaritalActions.load, (state: IMaritalState, action) => {
    return new StateBuilder<IMaritalState>(state).toLoading().build();
  }),
  on(MaritalActions.loadSuccess, (state: IMaritalState, action) => {
    return new StateBuilder<IMaritalState>(state, action).toLoaded().build();
  }),
  on(MaritalActions.submit, (state: IMaritalState, action) => {
    return new StateBuilder<IMaritalState>(state).toLoading().build();
  }),
  on(MaritalActions.submitSuccess, (state: IMaritalState, action) => {
    return new StateBuilder<IMaritalState>(state, action).toLoaded().build();
  })
);

export function maritalReducer(state: IMaritalState | undefined, action: Action) {
  return maritalReducerFn(state, action);
}
